import React from 'react';
import { Box, ShimmerBox, Text } from '@common-fe/common-fe';

import PreloaderServiceItem from './PreloaderServiceItem';

interface Props {
  title: string;
}
const ServiceCategoriesChart: React.FC<Props> = ({ title }) => {
  return (
    <Box fill>
      <Text size="medium" weight={700}>
        {title}
      </Text>

      <Box direction="row" background="canvas" margin={{ top: 'spacing16' }}>
        {/*19px */}
        <div>
          <ShimmerBox width="152px" align="center" justify="center" height="152px" round="50%">
            <Box width="114px" height="114px" round="50%" background="canvas" />
          </ShimmerBox>
        </div>
        <Box direction="column" fill gap="spacing24" margin={{ left: 'spacing16' }}>
          <PreloaderServiceItem />
          <PreloaderServiceItem />
          <PreloaderServiceItem />
        </Box>
      </Box>
    </Box>
  );
};

export default ServiceCategoriesChart;
